import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { HttpService } from '../../services/http.service';
import { ConsentsService } from '../../services/consents.service';
import { DynamicItem } from 'src/app/models/dynamicItem';
import { PopupConsentPinComponent } from '../popups/popup-consent-pin/popup-consent-pin.component';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  requestBlockEventId:string;
  dashboardData: any = {};

  hasConsentRequests = false;
  hasActiveConsents = false;
  hasNotifications = false;
  hasBankAccounts = false;
  showViewAllConsents = false;

  showPopupFlag: boolean = false;
  popupData: any;

  constructor(
    private http: HttpService,
    private consentService: ConsentsService,
    private route: Router,
    private commonService: CommonService
  ) {
  }

  ngOnInit() {
    this.getDashboardData();
  }

  /**
   * Getting Consents and Bank Accounts
   */
  getDashboardData() {
      let options = {
        type: 'get',
        url: 'dashboard',
        isDeveloper: true,
        includeUserSession: true
      }
      this.http.makeHttpRequest(options).subscribe(res => {
        if (res != undefined) {
          this.consentService.setData(res);
          this.dashboardData['bankAccounts'] = res['bankAccounts'];
          this.dashboardData['activeConsents'] = res['consents']['active'];
          this.dashboardData['consentRequests'] = res['consents']['pending'];
          this.showViewAllConsents = res['consents']['showViewAll'];
          this.dashboardData['notifications'] = res['notifications'];

          this.hasConsentRequests = this.dashboardData['consentRequests'] && this.dashboardData['consentRequests'].length; 
          this.hasActiveConsents = this.dashboardData['activeConsents'] && this.dashboardData['activeConsents'].length;
          this.hasNotifications = this.dashboardData['notifications'] && this.dashboardData['notifications'].length;
          this.hasBankAccounts = this.dashboardData['bankAccounts'] && this.dashboardData['bankAccounts'].length;
        }
      });
  }

  refreshDashboardData() {
    this.getDashboardData();
  }

  showpopup(event) {
    this.requestBlockEventId=event;
    
    let popuptext: any = {
      heading: "Consent Confirmation PIN",
      body: "Please Enter PIN to decline Consent",
      successCallback: this.declineConsent.bind(this),
      cancelCallback: this.closePopup.bind(this)
    }
    this.popupData = new DynamicItem(PopupConsentPinComponent, popuptext);
    this.showPopupFlag = true;
  }

  /**
   * To hide Popup, we are changing ngIf to false.
   */
  closePopup() {
    this.showPopupFlag = false;
  }

  /**
   * 
   * @param pin - Pin captured by the Popup 
   * @description - It is used to decline the request consents.
   * Here it is making an api call that is same to confirm the consent but the accounts array is empty.
   */
  declineConsent(pin){
    let options = {
      type: 'post',
      url: 'consentconfirm',
      isDeveloper: true,
      includeUserSession: true,
      data: {
        "refEventId": this.requestBlockEventId,
        "HexPIN": pin+"",
        "accounts": []
      }
    }
    this.http.makeHttpRequest(options).subscribe(res => {
      if (res["errorMessage"] == 'ConsentPinMisMatch') {
        this.showGlobalPopup("Consent Pin Mismatch", "ConsentPin Error");
        return;
      } else {
        this.closePopup();
      }

      this.refreshDashboardData();
    })
  }

  viewAllActiveConsents() {
    this.route.navigate(['/consent-history']);
  }

  linkNewAccount() {
    this.route.navigate(['/account-list']);
  }

  /**
   * To build and show global message popup
   * @param body popup body message
   * @param heading popup heading message
   */
  showGlobalPopup(body: string, heading?: string) {
    let popuptext = {
      heading: heading || "OnemoneyAA",
      body: body
    }

    this.commonService.showGlobalMessage(popuptext);
  }
}
